// src/pages/ResourcesPage.js

import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // <-- Import Link for React Router

function ResourcesPage() {
  return (
    <>
      {/* ------------------------------------------
          Inline Style to Force Montserrat Globally
          (Remove if using a global CSS file)
      ------------------------------------------- */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');

          body, h1, h2, h3, h4, h5, h6, p, .btn, .navbar-brand, .nav-link, label {
            font-family: 'Montserrat', sans-serif !important;
          }
        `}
      </style>

      {/* ========== RESOURCES PAGE HERO BANNER ========== */}
      <div
        style={{
          backgroundColor: '#003f5c',
          color: '#fff',
          padding: '6rem 0',
          textAlign: 'center',
        }}
      >
        <Container>
          <h1 style={{ fontWeight: '700', fontSize: '2.5rem' }}>
            BFS Resources & Information
          </h1>
          <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '1rem auto' }}>
            Explore our collection of articles, research papers, and helpful links to learn more about BFS.
          </p>
        </Container>
      </div>

      {/* ========== FEATURED RESOURCES SECTION ========== */}
      <div style={{ backgroundColor: '#f5f5f5', padding: '4rem 0' }}>
        <Container>
          <Row className="mb-4 text-center">
            <Col>
              <h2 style={{ fontWeight: '700', fontSize: '2rem' }}>Featured Resources</h2>
              <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '0.5rem auto' }}>
                Dive into these curated resources for in-depth knowledge about Benign Fasciculation Syndrome.
              </p>
            </Col>
          </Row>
          <Row>
            {[
              {
                title: 'BFS Overview',
                text: 'A comprehensive summary of the causes, symptoms, and latest research findings.',
                icon: 'https://cdn-icons-png.flaticon.com/128/9484/9484251.png',
                link: '#',
              },
              {
                title: 'Coping Strategies',
                text: 'Expert tips on managing twitch anxiety, stress reduction, and healthier routines.',
                icon: 'https://cdn-icons-png.flaticon.com/128/11288/11288968.png',
                link: '#',
              },
              {
                title: 'Community Forum',
                text: 'Join our online forum to connect with others who understand your BFS journey.',
                icon: 'https://cdn-icons-png.flaticon.com/128/7829/7829198.png',
                link: '#',
              },
            ].map((item, idx) => (
              <Col md={4} className="mb-4" key={idx}>
                <Card className="h-100 shadow-sm text-center">
                  <Card.Body>
                    <img
                      src={item.icon}
                      alt={`${item.title} icon`}
                      style={{ width: '60px', marginBottom: '1rem' }}
                    />
                    <Card.Title className="fw-semibold">{item.title}</Card.Title>
                    <Card.Text>{item.text}</Card.Text>
                    <Button variant="danger" href={item.link}>
                      Learn More
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* ========== DOWNLOADS / EXTERNAL LINKS SECTION ========== */}
      <div style={{ padding: '4rem 0' }}>
        <Container>
          <Row className="mb-4 text-center">
            <Col>
              <h2 style={{ fontWeight: '700', fontSize: '2rem' }}>
                Additional Resources
              </h2>
              <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '0.5rem auto' }}>
                Access official BFS guidelines, research papers, and community-led documents.
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={6} className="mb-4">
              <Card className="shadow-sm">
                <Card.Body>
                  <Card.Title className="fw-semibold">Official BFS Guidelines (PDF)</Card.Title>
                  <Card.Text>
                    Download the latest BFS guidelines compiled by BenignFasciculationSyndrome.org
                  </Card.Text>
                  <Button variant="danger" href="http://benignfasciculationsyndrome.org/assets/uploads/BFSPDF.pdf" download>
                    Download PDF
                  </Button>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} className="mb-4">
              <Card className="shadow-sm">
                <Card.Body>
                  <Card.Title className="fw-semibold">Research Paper Archive</Card.Title>
                  <Card.Text>
                    Browse a collection of peer-reviewed articles that delve into BFS pathophysiology
                    and management.
                  </Card.Text>
                  {/* Updated Link to /research-archive */}
                  <Button variant="danger" as={Link} to="/research-archive">
                    View Archive
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default ResourcesPage;
